export const PAY_STATUS = {
    SUCCESS:1,
    CLOSE:2,
    CANCEL:3
}
